module.exports = __webpack_public_path__ + "static/media/imge-4.78003641.jpg";